import { render, staticRenderFns } from "./consult-list.vue?vue&type=template&id=1a64c800&scoped=true"
import script from "./consult-list.vue?vue&type=script&lang=ts"
export * from "./consult-list.vue?vue&type=script&lang=ts"
import style0 from "./consult-list.vue?vue&type=style&index=0&id=1a64c800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64c800",
  null
  
)

export default component.exports